import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fcc2bd38&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=fcc2bd38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc2bd38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcc2bd38')) {
      api.createRecord('fcc2bd38', component.options)
    } else {
      api.reload('fcc2bd38', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fcc2bd38&scoped=true&", function () {
      api.rerender('fcc2bd38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/index.vue"
export default component.exports